import { useState, useEffect, useContext } from "react";
import LoginContext from "../../../store/login/LoginContext";
import Spinner from "../../ui/spinner/Spinner";
import styles from "./ContactUs.module.css"
import axios from "axios";

const regexEmail = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
const emailValidation = (value) => {
  const normalized = value.trim().toLowerCase();
  return (
    regexEmail.test(normalized) &&
    normalized.length >= 6 &&
    normalized.length <= 72
  );
};

const regex = /^[0-9a-zA-Z .,-;']{10,250}$/;
const messageValidation = (value) =>
  !value ? false : regex.test(value.trim());

const ContactUs = (props) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [serverError, setServerError] = useState("");
  const loginCtx = useContext(LoginContext);
  const [email, setEmail] = useState("");
  const [emailHasError, setEmailHasError] = useState();
  const [message, setMessage] = useState("");
  const [messageHasError, setMessageHasError] = useState();

  const submitHandler = async () => {
    if (!message) {
        alert("Error detected", "All fields must be filled correctly");
        return;
    }
    if (email && !emailValidation(email)) {
      setEmailHasError(true);
      return;
    } else {
      setEmailHasError(false);
    }

    if (!messageValidation(message)) {
      setMessageHasError(true);
      return;
    } else {
      setMessageHasError(false);
    }

    console.log("message data:", { isLoggedIn: loginCtx.isLoggedIn, email, message });
    try {
      const response = await axios.post(
        "php/sign_in/submit_message.php",
        { isLoggedIn: loginCtx.isLoggedIn, email, message },
        { headers: { "Content-Type": "application/json" } },
      );

      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);

      if (response.data.code !== 200) {
        alert(
          "The server may not be available. Please check your internet connection",
        );
        setServerError(
          response.data?.message || "Message submission failed. Please retry",
        );
        return;
      }

      alert("Your message has been submitted");
      if (!loginCtx.isLoggedIn) props.onCancel();
      else props.onSubmit();

    } catch (error) {
      if (data.code !== 200) {
        alert(data?.message || "Error connecting to server. Please retry.");
        setServerError(
          data?.message || "Error connecting to server. Please retry.",
        );
        return;
      }
      
    } finally {
      setShowSpinner(false);
    }      
  };
  
  return (
    <div className={styles.classes}>
      <header>
        <h2>Contact us </h2>
        <strong>Please fill the form below</strong>
      </header>
      <ol>
        <li>
          <strong>Email: </strong> (This is optional). If you want us to contact
          you by email, please enter a valid email
        </li>
        <li>
          <strong>Message: </strong>
          Length between 10-250 characters. Only alphanumerics , . - ; are
          allowed
        </li>
      </ol>
      <div className={styles.inputView}>
        <label htmlFor="email">Email</label>
        <input
          id="email"
          placeholder="Enter your email"
          maxLength={24}
          required
          autoComplete="off"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value.trim().toLowerCase())}
        />
        {emailHasError && (
          <span className={styles.errorText}>Your email is invalid</span>
        )}
      </div>
      <div>
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          rows={10}
          cols={60}
          maxLength={450}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        {messageHasError || serverError && <p className={styles.errorText}>{"Invalid message" || serverError}</p>}
      </div>
      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
        >
          Submit
        </button>
        <button className={styles.bgRed} type="button" onClick={props.onCancel}>
          Cancel
        </button>
      </div>
      {showSpinner && <Spinner />}
    </div>
  );
};

export default ContactUs;
